import React, { useState } from "react";

import { useUserInfoContext } from "@/contexts";
import authAxiosInstance from "@/sevices/authAxiosInstance";
import { Credit } from "@/types/Credit";
import { ErrorTypes } from "@/utils/Errors/errorMessages";
import { getErrorMessage } from "@/utils/Errors/getErrorMessage";

export const useCreditDetail = () => {
  const [creditDetail, setCreditDetail] = useState<Credit | null>(null);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const { userInfo } = useUserInfoContext() as {
    userInfo: { userId: string };
  };

  const fetchCredit = React.useCallback(
    async (creditNum: string) => {
      setIsLoading(true);
      setError(null);
      try {
        const response = await authAxiosInstance({
          url: `/invoiceservice/api/v1/credit/${creditNum}`,
          method: "GET",
          params: { userId: userInfo?.userId }
        });
        const data = response.data;
        setCreditDetail(data);
        return data;
      } catch (err) {
        setError(getErrorMessage(ErrorTypes.CreditErrors, err));
        return null;
      } finally {
        setIsLoading(false);
      }
    },
    [userInfo?.userId]
  );

  return {
    fetchCredit,
    creditDetail,
    isLoading,
    error,
    setCreditDetail,
    setIsLoading,
    setError
  };
};
